import { birthSchemaObject } from 'shell/constants/create-schema-birth';
import { PageMode } from 'civil-status/view-models/page-mode';
import * as yup from 'yup';
import { ObjectShape } from 'yup/lib/object';

const createSchema = (mode: PageMode): yup.ObjectSchema<ObjectShape> => {
  let schemaObject: ObjectShape = {};

  if (mode === PageMode.Edit) {
    schemaObject = birthSchemaObject;
  }

  return yup.object().shape(schemaObject);
};

export default createSchema;
